import { Experiment } from '@cian/experiments/ab';
import { AuthMotivation, CianChatError } from '@cian/newbuilding-chat-component/';
import { IconCommunicationConsultant16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  closeAutorisationMotivationConsultantCianChat,
  closeErrorMessage,
} from 'shared/actions/consultantCianChat/actions';
import { selectNewbuildingKpnChatEnabled } from 'shared/selectors/abExperiments';
import { isAutorisationPopupOpenSelector, isErrorPopupOpenedSelector } from 'shared/selectors/consultantChat';
import { selectChatRequestStatus } from 'shared/selectors/offerChat';
import { regionIdSelector } from 'shared/selectors/offerData/geo/regionIdSelector';
import { selectTrackingUrl } from 'shared/selectors/offerData/selectTrackingUrl';

import { SendMessageButtonContainer } from './SendMessageButton';
import { ChatOnboardingContainer } from '../../ChatOnboardingContainer';
import { onEntryAutorisationPopupClick } from './analytics/analytics';
import { useConsultantCianChat } from './hooks/useConsultantCianChat';
import { useApplicationContext } from '../../ApplicationContext';

interface INewbuildingMessageButtonContainerProps {
  isPhonesOpened: boolean;
}

const PLACE_TYPE = 'Open_card_floating_block';

export const NewbuildingConsultantMessageButtonContainer: React.FC<INewbuildingMessageButtonContainerProps> = ({
  isPhonesOpened,
}) => {
  const dispatch = useDispatch();
  const regionId = useSelector(regionIdSelector);
  const customLabel = useSelector(selectTrackingUrl);
  const isKpnChatsEnabled = useSelector(selectNewbuildingKpnChatEnabled);
  const isChatsRequestFinished = useSelector(selectChatRequestStatus) === 'finished';
  const isAutorisationPopupOpen = useSelector(isAutorisationPopupOpenSelector);
  const isErrorPopupOpened = useSelector(isErrorPopupOpenedSelector);
  const { telemetry } = useApplicationContext();
  const { handleOpenChat } = useConsultantCianChat();

  const onLogInClick = React.useCallback(() => {
    onEntryAutorisationPopupClick({ regionId, customPageURL: customLabel });
    telemetry.increment('offer_card.send_message_click.newbuilding_consultant');
    handleOpenChat();
  }, [customLabel, handleOpenChat, regionId]);

  const onLogInClose = React.useCallback(() => {
    dispatch(closeAutorisationMotivationConsultantCianChat());
  }, [dispatch]);

  const onErrorClose = React.useCallback(() => {
    dispatch(closeErrorMessage());
  }, [dispatch]);

  if (!isKpnChatsEnabled || !isChatsRequestFinished) {
    return null;
  }

  return (
    <Experiment name="newbuilding_kpn_chats_cpl_card_desktop" group="B">
      {isPhonesOpened ? (
        <SendMessageButtonContainer title="Написать в чат" theme="fill_primary" noMarginTop placeType={PLACE_TYPE} />
      ) : (
        <ChatOnboardingContainer type="consultant" theme="blue" placement="top-end" maxWidth="115px">
          <SendMessageButtonContainer
            title={null}
            theme="fill_secondary"
            ariaLabel="Написать застройщику"
            beforeIcon={<IconCommunicationConsultant16 color="icon-main-default" />}
            noMarginTop
            placeType={PLACE_TYPE}
          />
        </ChatOnboardingContainer>
      )}
      <AuthMotivation
        isAutorisationPopupOpened={isAutorisationPopupOpen}
        onClick={onLogInClick}
        onClose={onLogInClose}
      />
      <CianChatError onClose={onErrorClose} open={isErrorPopupOpened} />
    </Experiment>
  );
};
